export const FormFieldUpdateStatus = {
  UPDATED: 'UPDATED',
  REMOVED: 'REMOVED',
  NO_CHANGE: 'NO_CHANGE',
};

Object.freeze(FormFieldUpdateStatus);
